<div class="portal-content-wrapper">
    <router-outlet></router-outlet>
</div>
